module.exports = __webpack_public_path__ + "img/travel_slippers.98048b26.png";